import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { initSentry, SentryErrorBoundary } from './lib/sentry.js'

// Sentry must be initialised before any React component mounts so it
// catches errors that happen during the very first render. Gated on
// VITE_SENTRY_DSN being set — absence is a clean no-op.
initSentry()

// Fallback shown when a component crash escapes a child boundary. Kept
// minimal — the goal is "graceful degradation, not detailed diagnostics".
const RootFallback = () => (
  <div style={{
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: '#000', color: '#fff', fontFamily: 'system-ui, sans-serif', padding: 24,
  }}>
    <div style={{ maxWidth: 480, textAlign: 'center' }}>
      <div style={{ fontSize: 40, marginBottom: 14 }}>⚠</div>
      <h1 style={{ fontSize: 22, margin: '0 0 10px' }}>Something went wrong.</h1>
      <p style={{ color: '#999', fontSize: 14, lineHeight: 1.6, margin: '0 0 22px' }}>
        We've been notified and are looking into it. Try refreshing — if it keeps happening, email us at <a style={{color:'#00f0a0'}} href="mailto:hello@mediaonautopilot.com">hello@mediaonautopilot.com</a>.
      </p>
      <button onClick={() => window.location.reload()} style={{
        background: '#00f0a0', color: '#000', border: 'none', borderRadius: 10,
        padding: '10px 22px', fontSize: 14, fontWeight: 700, cursor: 'pointer',
      }}>
        Reload
      </button>
    </div>
  </div>
)

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={<RootFallback />}>
      <App />
    </SentryErrorBoundary>
  </React.StrictMode>,
)
